import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { ExplanationAccordion } from 'components'
import { VehicleCheckInManufacturerLabelDatesDto, vehicleCheckInManufacturerLabelDatesValidationSchema } from 'dtos'
import { Formik } from 'formik'
import moment from 'moment'

interface ManufacturerLabelEditDialogProps {
  initialValues: VehicleCheckInManufacturerLabelDatesDto
  open: boolean
  onClose: () => void
  onSave: (values: any) => void
  isLoading: boolean
}

export default function ManufacturerLabelEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: ManufacturerLabelEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={vehicleCheckInManufacturerLabelDatesValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={2} alignItems='center'>
                <DialogTitle>Manufacturer Label</DialogTitle>
                <Grid item xs={12}>
                  <DatePicker
                    disabled={isLoading || isSubmitting}
                    label='Manufacturer Label Ordered'
                    onChange={newValue => {
                      if (newValue) {
                        setFieldValue('manufacturerLabelOrderedDate', newValue.format('yyyy-MM-DD'))
                      } else {
                        setFieldValue('manufacturerLabelOrderedDate', undefined)
                      }
                    }}
                    slotProps={{
                      actionBar: {
                        actions: ['clear']
                      },
                      textField: {
                        error: Boolean(touched.manufacturerLabelOrderedDate && errors.manufacturerLabelOrderedDate),
                        helperText: touched.manufacturerLabelOrderedDate && errors.manufacturerLabelOrderedDate
                      }
                    }}
                    value={values.manufacturerLabelOrderedDate ? moment(values.manufacturerLabelOrderedDate) : null}
                  />
                </Grid>

                <Grid item xs={12}>
                  <DatePicker
                    disabled={isLoading || isSubmitting}
                    label='Manufacturer Label Received'
                    onChange={newValue => {
                      if (newValue) {
                        setFieldValue('manufacturerLabelReceivedDate', newValue.format('yyyy-MM-DD'))
                      } else {
                        setFieldValue('manufacturerLabelReceivedDate', undefined)
                      }
                    }}
                    slotProps={{
                      actionBar: {
                        actions: ['clear']
                      },
                      textField: {
                        error: Boolean(touched.manufacturerLabelReceivedDate && errors.manufacturerLabelReceivedDate),
                        helperText: touched.manufacturerLabelReceivedDate && errors.manufacturerLabelReceivedDate
                      }
                    }}
                    value={values.manufacturerLabelReceivedDate ? moment(values.manufacturerLabelReceivedDate) : null}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ mt: 2 }}>
                <ExplanationAccordion>Neither field is pre-populated nor required to save.</ExplanationAccordion>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button color='inherit' onClick={onClose} variant='text'>
                CANCEL
              </Button>

              <LoadingButton color='primary' type='submit' loading={isSubmitting || isLoading} variant='contained'>
                Save
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  )
}
